import { render, staticRenderFns } from "./FormioFormBuilder.vue?vue&type=template&id=006dda2b&scoped=true&"
import script from "./FormioFormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormioFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormioFormBuilder.vue?vue&type=style&index=0&id=006dda2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006dda2b",
  null
  
)

export default component.exports